import { render } from "./mhbHome.vue?vue&type=template&id=0808a241&scoped=true"
import script from "./mhbHome.vue?vue&type=script&lang=js"
export * from "./mhbHome.vue?vue&type=script&lang=js"

import "./mhbHome.vue?vue&type=style&index=0&id=0808a241&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0808a241"]])

export default __exports__